import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const PasswordToggle = ({ inputRef }) => {
  const [inputType, setInputType] = useState("password");

  const onClick = () => {
    inputRef.current.type =
      inputRef.current.type === "password" ? "text" : "password";

    setInputType(inputRef.current.type);
  };

  return (
    <div className="dc-login_icon ml-1 mr-2" onClick={onClick}>
      {inputType === "password" ? (
        <FontAwesomeIcon
          icon={["fas", "eye-slash"]}
          size="lg"
          color="#69717a"
        />
      ) : (
        <FontAwesomeIcon icon={["fas", "eye"]} size="lg" color="#69717a" />
      )}
    </div>
  );
};
